import util from './util.js' /*引入 公共工具 模块*/
import use400 from '../common/use400.js'
// import use400_hy from '../common/use400_hy.js'
import getCookieValue from '../common/getCookieValue.js'
import drawCommonModel from './drawCommonModel.js'
import {buildExposureInfo,exposureForCardUpdate} from '../common/exposureForCard.js'
import {exposureRegister,exposureUpdate} from '../common/luna_track/exposure'
import {report} from '../common/luna_track/clickReport'

export default {
    list_container: drawList_Container /*列表容器 绘制 模块*/,
    list_content: drawList_Content /*列表内容 绘制 模块*/,
    drawList_1_row_Container: drawList_1_row_Container /*行布局列表容器 绘制 模块*/,
    drawList_2_row_Container: drawList_2_row_Container /*行布局列表容器 绘制 模块*/,
    drawList_tag_Container
}

let $data = {
    creativeid: ____json4fe.creativeid,
    getFangresult(id) {
        let { fangStitchingRulesMap } = $data
        if ([13, 14, 15].includes(id)) {
            return fangStitchingRulesMap['fang_shangye']
        } else if ([8, 10, 12].includes(id)) {
            return fangStitchingRulesMap[`fang_${id}`]
        } else {
            return fangStitchingRulesMap['fang_default']
        }
    },
    fangStitchingRulesMap: {
        fang_8({
            quyu = '',
            estate = '',
            tingshi = '',
            quyu2 = '',
            area = '',
            toward = ''
        }) {
            return {
                title: `${quyu} ${estate} ${tingshi}`,
                describe: [quyu2, area, toward].filter(item => !!item)
            }
        },
        fang_10({
            quyu = '',
            estate = '',
            roomcount = '',
            woshi = '',
            quyu2 = '',
            area = '',
            toward = ''
        }) {
            return {
                title: `${quyu} ${estate} ${roomcount} ${woshi}`,
                describe: [quyu2, area, toward].filter(item => !!item)
            }
        },
        fang_12({
            quyu = '',
            estate = '',
            tingshi = '',
            area = '',
            quyu2 = '',
            toward = '',
            zhuangxiu = ''
        }) {
            return {
                title: `${quyu} ${estate} ${tingshi} ${area}`,
                describe: [quyu2, toward, zhuangxiu].filter(item => !!item)
            }
        },
        fang_shangye({
            quyu = '',
            type = '',
            area = '',
            quyu2 = '',
            sumprice = '面议'
        }) {
            return {
                title: `${quyu} ${type} ${area}`,
                describe: [quyu2, area, sumprice].filter(item => !!item)
            }
        },
        fang_default({ title = '' } = {}) {
            return {
                title,
                describe: []
            }
        }
    },
    getJobFlbz({
        jobtype = '',
        flbz = '',
        zhaopinrenshu = '',
        xinzijiesuan = ''
    } = {}) {
        let { type = '招聘' } = __modelObj
        if (jobtype === '兼职招聘') {
            return [`招${zhaopinrenshu}人`, xinzijiesuan, '经验不限'].filter(
                item => !!item
            )
        } else {
            return flbz.split(',').filter(item => !!item)
        }
    }
}

/**
 * 列表容器 绘制 模块
 *
 * @param  {Object} data
 * 详见pageMock.js文件中"modelType":"list"对象
 *
 * @return {String}
 * 拼接后的dom
 */
function drawList_Container(data, cName) {
    var item = data.infoList.length ? data.infoList[0] : {},
        { tag = '' } = data
    cName = cName ? cName : ''
    return `<section class="list-model list-model-col ${cName} section-${item.listStyle}">
				<h1 class="list-title${
                    data.infoList ? ` list-title-${data.infoList.length}` : ''
                }">
				${data.infoList
                    .map(
                        (item, index) => `
					<span ${index === 0 ? 'class="list-title-active"' : ''}>
						<p data-cateid="${item.cateid}" data-num="${item.num}"  data-catename="${
                            item.catename
                        }" data-liststyle="${item.listStyle}" data-modeltype="${
                            data.modelType
                        }" ${tag ? `data-tag="${tag}-${index + 1}"` : ''}>
							${item.title}
						</p>
					</span>
				`
                    )
                    .join('')}
				</h1>
				<div class="list-content"></div>
			</section>`
}
function drawList_1_row_Container(data,moduleIndex) {
    var item = data.infoList.length ? data.infoList[0] : {}
    return `<section class="list-model list-model-new list-model-row-1 section-${
        item.listStyle
    }">
		<p 
			class="hiddenEle"
			data-cateid="${item.cateid}"
			data-num="${item.num}"
			data-catename="${item.catename}"
			data-liststyle="${item.listStyle}"
			data-modeltype="${data.modelType}"
			data-tag="${data.tag}"
		></p>
		${drawCommonModel.drawTitleModel(data,moduleIndex)}
		<div class="list-content"></div>
	</section>`
}
function drawList_2_row_Container(data) {
    var num = Math.floor(Math.random() * data.infoList.length)
    var item = data.infoList.length ? data.infoList[num] : {}
    return `<section class="list-model list-model-new list-model-row-2">
				${
                    data.iconUrl
                        ? `
					<a class="list-title-img" ${
                        data.linkUrl.trim()
                            ? `href="${data.linkUrl.trim()}&tag=${
                                  data.tag
                              }" data-tag="${data.tag}" `
                            : ''
                    }>
						<img src="${data.iconUrl}"/>
					</a>`
                        : ''
                }
				<div class="list-content" data-class="list-content">
				</div>
				<p class="hiddenEle" data-cateid="${item.cateid}" data-num="${
        item.num
    }"  data-catename="${item.catename}" data-liststyle="${
        item.listStyle ? item.listStyle : '2row'
    }" data-tip="${item.tip}"></p>
			</section>`
}

function drawList_tag_Container(data) {
    return `<section class="list-model list-model-col list-model-tag">
		<ul class="title-container">
			${data.infoList
                .map(
                    (item, index) => `
				<li class="title-item ${index === 0 ? 'list-title-active' : ''}"
					data-cateid="${item.cateid}"
					data-num="${item.num}"
					data-catename="${item.catename}"
					data-filter="${item.filter}"
					data-liststyle="${item.listStyle}"
					${data.tag ? `data-tag="${data.tag}-${index + 1}"` : ''}>
					${item.title}
				</li>
			`
                )
                .join('')}
		</ul>
		<div class="list-content"></div>
	</section>`
}
var abtest = util.getCookie('abtest')

var stategies = {
    qzzp: function(item,{exposureInfo}) {
        return `<a class="list-item visiblereport-luna-card clickreport-luna-post${
            item.adType === 20 ? ' list-item-hide' : ''
        }" href="${item.targeturl}" data-exposurelog='${exposureInfo}' data-title='${item.title}' data-tags='${(item.flbz || '').split(',')}'>
			<h2>${item.title}</h2>
			<div class="list-item-tr1">
				${
                    item.jobtype
                        ? `<span class="list-item-position">${item.jobtype}</span>`
                        : ''
                }
				<span class="list-item-price">${item.salary}</span>
			</div>
			<div class="list-item-tr2">
				${
                    item.flbz
                        ? item.flbz
                              .split(',')
                              .map(
                                  (item, index) => `
						${index <= 3 ? `<span class="list-item-flbz">${item}</span>` : ''}
					`
                              )
                              .join('')
                        : ''
                }
				<span class="list-item-address">${item.address}</span>
			</div>
            <div class="${abtest.includes('advertising_rectification_a') && item.flbz && item.flbz.includes('广告') ? 'delIcon' : 'noIcon'}">
                <img src="//wos.58cdn.com.cn/cDazYxWcDHJ/picasso/etlmivee__w24_h24.png" alt="">
            </div>
		</a>`
    },
    jzzp: function(item,{exposureInfo}) {
        return `<a class="list-item visiblereport-luna-card clickreport-luna-post${
            item.adType === 20 ? ' list-item-hide' : ''
        }" href="${item.targeturl}" data-exposurelog='${exposureInfo}'>
			<h2>${item.title}</h2>
			<div class="list-item-tr1">
				${
                    item.jobtype
                        ? `<span class="list-item-position">${item.jobtype}</span>`
                        : ''
                }
				<span class="list-item-price">${item.salary}</span>
			</div>
			<div class="list-item-tr2">
				${
                    item.zhaopinrenshu
                        ? `<span class="list-item-flbz">招${item.zhaopinrenshu}人</span>`
                        : ''
                }
				${item.yan === '0' ? '<span class="list-item-flbz">经验不限</span>' : ''}
				${
                    item.xinzijiesuan
                        ? `<span class="list-item-flbz">${item.xinzijiesuan}</span>`
                        : ''
                }
				<span class="list-item-address">${item.address}</span>
			</div>
		</a>`
    },
    cw: function(item,{exposureInfo}) {
        var describe = []
        !!item.adtag && describe.push('广告')
        !!item.yimiaoqingkuang && describe.push(`${item.yimiaoqingkuang}疫苗`)
        !!item.quchongqingkuang && describe.push(item.quchongqingkuang)
        return `<a class="list_demo_a visiblereport-luna-card clickreport-luna-post${
            item.adType === 20 ? ' list-item-hide' : ''
        }" href="${item.targeturl}" data-exposurelog='${exposureInfo}'>
            <img src="${item.pic}">
            <dl class="list_right">
	            <dt class="item_title">${item.title}</dt>
	            <dd class="attr-demo">${describe.join('/')}</dd>
	            <dd class="thirddd">
	            	<span class="price-demo">${item.price}</span>
	            	<span class="list-demo-time">${item.posttime.split(' ')[0]}</span>
	            </dd>
            </dl>
            <div class="${abtest.includes('advertising_rectification_a') && describe.includes('广告') ? 'delIcon' : 'noIcon'}">
            </div>
        </a>`
    },
    eswp: function(item,{exposureInfo}) {
        var describe = []
        !!item.quyu && describe.push(item.quyu)
        !!item.oldlevel && describe.push(item.oldlevel)
        return `<a class="list_demo_a visiblereport-luna-card clickreport-luna-post${
            item.adType === 20 ? ' list-item-hide' : ''
        }" href="${item.targeturl}" data-exposurelog='${exposureInfo}'>
            <img src="${item.pic}">
            <dl class="list_right">
	            <dt class="item_title">${item.title}</dt>
	            <dd class="attr-demo">${describe.join('/')}</dd>
	            <dd class="thirddd">
	            	<span class="price-demo">${item.price}</span>
	            	<span class="list-demo-time">${item.posttime.split(' ')[0]}</span>
	            </dd>
            </dl>
        </a>`
    },
    esc: function(item,{exposureInfo}) {
        var describe = []
        !!item.adtag && describe.push('广告')
        !!item.shangpainianyue &&
            describe.push(`${item.shangpainianyue.substr(0, 4)}年上牌`)
        !!item.rundistance && describe.push(`行驶${item.rundistance}`)
        return `<a class="list_demo_a visiblereport-luna-card clickreport-luna-post${
            item.adType === 20 ? ' list-item-hide' : ''
        }" href="${item.targeturl}" data-exposurelog='${exposureInfo}'>
            <img src="${item.pic}">
            <dl class="list_right">
	            <dt class="item_title">${item.title}</dt>
	            <dd class="attr-demo">${describe.join('/')}</dd>
	            <dd class="thirddd">
	            	<span class="price-demo">${item.price}</span>
	            	<span class="list-demo-time">${item.posttime.split(' ')[0]}</span>
	            </dd>
            </dl>
        </a>`
    },
    esf: function(item,{exposureInfo}) {
        var describe = []
        !!item.quyu && describe.push(item.quyu)
        !!item.estate && describe.push(item.estate)
        !!item.tingshi && describe.push(item.tingshi)
        return `<a class="list_demo_a visiblereport-luna-card clickreport-luna-post${
            item.adType === 20 ? ' list-item-hide' : ''
        }" href="${item.targeturl}" data-exposurelog='${exposureInfo}' data-adtype="${item.adType}" data-encrypturl="${item.encryptUrl}">
            <img src="${item.pic}">
            <dl class="list_right">
	            <dt class="item_title">${item.title}</dt>
	            <dd class="attr-demo">${describe.join('/')}</dd>
	            <dd class="thirddd">
	            	<span class="price-demo">${item.price}</span>
	            	<span class="list-demo-time">${item.posttime.split(' ')[0]}</span>
	            </dd>
            </dl>
        </a>`
    },
    zz: function(item,{exposureInfo}) {
        var describe = []
        !!item.quyu && describe.push(item.quyu)
        !!item.estate && describe.push(item.estate)
        !!item.tingshi && describe.push(item.tingshi)
        return `<a class="list_demo_a visiblereport-luna-card clickreport-luna-post${
            item.adType === 20 ? ' list-item-hide' : ''
        }" href="${item.targeturl}" data-exposurelog='${exposureInfo}' data-adtype="${item.adType}" data-encrypturl="${item.encryptUrl}">
            <img src="${item.pic}">
            <dl class="list_right">
	            <dt class="item_title">${item.title}</dt>
	            <dd class="attr-demo">${describe.join('/')}</dd>
	            <dd class="thirddd">
	            	<span class="price-demo">${item.price}</span>
	            	<span class="list-demo-time">${item.posttime.split(' ')[0]}</span>
	            </dd>
            </dl>
        </a>`
    },
    hz: function(item,{exposureInfo}) {
        var describe = []
        !!item.quyu && describe.push(item.quyu)
        !!item.estate && describe.push(item.estate)
        !!item.woshi && describe.push(item.woshi)
        return `<a class="list_demo_a visiblereport-luna-card clickreport-luna-post${
            item.adType === 20 ? ' list-item-hide' : ''
        }" href="${item.targeturl}" data-exposurelog='${exposureInfo}' data-adtype="${item.adType}" data-encrypturl="${item.encryptUrl}">
            <img src="${item.pic}">
            <dl class="list_right">
	            <dt class="item_title">${item.title}</dt>
	            <dd class="attr-demo">${describe.join('/')}</dd>
	            <dd class="thirddd">
	            	<span class="price-demo">${item.price}</span>
	            	<span class="list-demo-time">${item.posttime.split(' ')[0]}</span>
	            </dd>
            </dl>
        </a>`
    },
    hynopic: function(item, params) {
        const {exposureInfo} = params;
        //黄页无图
        let tagArr = []
        if (item.huiyuan > 0) {
            //会员几年
            tagArr.push(`<span>会员${item.huiyuan}年</span>`)
        }
        if (item.credit) {
            //企业认证、个人认证、微信认证
            item.credit
                .trim()
                .split(',')
                .forEach(function(str) {
                    tagArr.push(`<span>${str}</span>`)
                })
        }
        if (tagArr.length == 0) {
            tagArr.push('<span>本地商家</span>')
        }
        if (tagArr.length > 2) {
            tagArr.length = 2
        }
        let tag = `lunajuhe-dtl-${params.showIndex}-${params.catename}-${params.creativeid}-${params.abtest}`
        return `
			<a class="list_demo_a visiblereport-luna-card clickreport-luna-post${
                item.adType === 20 ? ' list-item-hide' : ''
            }" data-tag="${tag}" href="${
            item.targeturl
        }" data-exposurelog='${exposureInfo}'>
				<p class="item_title">${item.title}</p>
				<p class="attr-demo">${
                    item.szone ? `${item.szone.replace(/，/g, '·')}` : ''
                }</p>
				<div class="thirddd"> 	
					${item.adType === 20 ? '' : `<p class="tagBox">${tagArr.join('')}</p>`}
					<span class="detailBtn">查看详情</span>
				</div>
			</a>
		`
    },
    hypic: function(item, params) {
        const {exposureInfo} = params;
        //黄页有图
        let tagArr = []
        if (item.servicefeature) {
            //服务特色
            item.servicefeature
                .trim()
                .split(' ')
                .forEach(function(str) {
                    tagArr.push(`<span>${str}</span>`)
                })
        }
        if (item.servicelimit) {
            //服务范围
            item.servicelimit
                .trim()
                .split(' ')
                .forEach(function(str) {
                    tagArr.push(`<span>${str.split('|')[0]}</span>`)
                })
        }
        if (
            !!item.businessinfo &&
            (item.businessinfo.popularityVal > 4 ||
                item.businessinfo.serviceVal > 4 ||
                item.businessinfo.activeVal > 4)
        ) {
            //高分商家
            tagArr.push('<span>高分商家</span>')
        }
        if (!!item.businessinfo && !!item.businessinfo.segment) {
            //商家等级
            tagArr.push(`<span>${item.businessinfo.segment}</span>`)
        }
        if (item.chengxinshangjia == 'true') {
            //诚信商家
            tagArr.push('<span>诚信商家</span>')
        }
        if (tagArr.length == 0) {
            tagArr.push('<span>本地商家</span>')
        }
        if (tagArr.length > 2) {
            tagArr.length = 2
        }
        let tag = `lunajuhe-dtl-${params.showIndex}-${params.catename}-${params.creativeid}-${params.abtest}`
        return `
			<a class="list_demo_a visiblereport-luna-card clickreport-luna-post${
                item.adType === 20 ? ' list-item-hide' : ''
            }" data-tag="${tag}" href="${
            item.targeturl
        }" data-exposurelog='${exposureInfo}'>
				<img src="${item.coverimg}">
				<dl class="list_right">
					<dt class="item_title">${item.title}</dt>
					<dd class="attr-demo">${
                        item.szone ? `${item.szone.replace(/，/g, '·')}` : ''
                    }</dd>
					${item.adType === 20 ? '' : `<p class="tagBox">${tagArr.join('')}</p>`}
				</dl>
			</a>
		`
    },
    '2row': function(list, tip) {
        //两行单类轮播
        let html = '',
            subHtmlArr = [],
            subHtmlCur = ''
        let showNum = -1
        list.map(function(item, index) {
            subHtmlCur += `
					<a class="list_demo_a ${item.adType === 20 ? ' list-item-hide' : ''}" href="${
                item.targeturl
            }">
						<p class="item_title">${item.title}</p>
						${tip.trim() ? `<span>${tip}</span>` : ''}
					</a>
				`
            if (item.adType != 20) {
                showNum++
            }
            if (
                showNum % 2 == 1 ||
                (index == list.length - 1 && showNum == 0)
            ) {
                subHtmlArr.push(subHtmlCur)
                // html.push(`<li class="swiper-slide ${showNum == 0 ? 'list-item-hide' : ''}">${subHtmlCur}</li>`)
                subHtmlCur = ''
                showNum = -1
            }
            if (index == list.length - 1 && showNum == -1 && subHtmlCur != '') {
                subHtmlArr[subHtmlArr.length - 1] =
                    subHtmlArr[subHtmlArr.length - 1] + subHtmlCur
                subHtmlCur = ''
                showNum == -1
            }
        })
        html = subHtmlArr
            .map(item => `<li class="swiper-slide">${item}</li>`)
            .join('')
        return html
    },
    hydt: function(item, params) {
        const {exposureInfo} = params;
        //黄页单页
        let tag = `lunajuhe-list-${params.listIndex}-${params.showIndex}-${params.creativeid}-${params.abtest}`
        let tagArr = []
        if (item.huiyuan > 0) {
            //会员几年
            tagArr.push(`<span>会员${item.huiyuan}年</span>`)
        }
        if (item.credit) {
            //企业认证、个人认证、微信认证
            item.credit
                .trim()
                .split(',')
                .forEach(function(str) {
                    tagArr.push(`<span>${str}</span>`)
                })
        }
        if (item.chengxinshangjia == 'true') {
            //诚信商家
            tagArr.push('<span>诚信商家</span>')
        }
        if (tagArr.length == 0) {
            //诚信商家
            tagArr.push('<span>认证商家</span>')
        }
        if (tagArr.length > 3) {
            tagArr.length = 3
        }
        return `
		<li class="list-item visiblereport-luna-card ${
            item.adType === 20 ? ' list-item-hide' : ''
        }" data-exposurelog=${exposureInfo}>
			<a class="list_demo_a clickreport-luna-post" data-tag="${tag}" href="${
            item.targeturl
        }">
				<img src="${item.coverimg}">
				<dl class="list_right">
					<dt class="item_title">${item.title}</dt>
					<dd class="attr-demo">${
                        item.szone
                            ? `<i class="addrIcon"></i>${item.szone.replace(
                                  /，/g,
                                  '·'
                              )}`
                            : ''
                    }</dd>
					${item.adType === 20 ? '' : `<p class="tagBox">${tagArr.join('')}</p>`}
				</dl>
			</a>
			<div class="telBox clickreport-luna-tel" data-exposurelog='${JSON.stringify({
    sid: item.sid,
    infoId: item.infoId,
    slot: item.slot,
    pos: item.pos
})}' data-infoid="${item.infoId}" data-infotype="${
            item.infoType
        }" data-uniquesign="${item.uniquesign}" data-tel="${
            item.phone
        }" data-url="${item.targeturl}" data-adtype="${item.adType}" data-sid="${item.sid}" data-slot="${item.slot}" data-pos="${item.pos}" data-businfo="${item.ext && item.ext.busInfo || ''}" data-busTransInfo="${item.ext && item.ext.busTransInfo || ''}"></div>
		<div class="${abtest.includes('advertising_rectification_a') && item.credit && item.credit.includes('广告') ? 'delIcon' : 'noIcon'}">
            <img src="//wos.58cdn.com.cn/cDazYxWcDHJ/picasso/etlmivee__w24_h24.png" alt="">
        </div>
        </li>`
    },
    fcxt: (
        {
            cateid = '',
            targeturl = 'javascript:void(0);',
            adType = 20,
            pic = '//img.58cdn.com.cn/n/images/list/noimg2.gif',
            anxuan = 'false',
            videourl = '',
            applable = '',
            price = '',
            encryptUrl = '',
            ...info
        } = {},
        { showIndex, tag,exposureInfo }
    ) => {
        let { title = '', describe = '' } = $data.getFangresult(cateid)(info)
        return `<a href="${targeturl}" class="list-item visiblereport-luna-card clickreport-luna-post ${
            adType === 20 ? 'list-item-hide' : ''
        }" data-tag="${tag}-${showIndex}" data-exposurelog='${exposureInfo}' data-adtype="${adType}" data-encrypturl="${encryptUrl}">
			<div class="img-container ${
                videourl ? 'canplay' : ''
            }" style="background-image: url('${pic}')">
				${anxuan === 'true' ? '<span class="img-corner">安选</span>' : ''}
			</div>
			<ul class="content-container">
				<li class="title-line">${title}</li>
				<li class="describe">${describe.join('/')}</li>
				<li class="tags-line">
					${applable
                        .split(',')
                        .filter(item => !!item)
                        .map(item => `<span class="tag">${item}</span>`)
                        .join('')}
				</li>
				<li class="price-line">${price}</li>
			</ul>
		</a>`
    },
    fcdt1: (
        {
            cateid = '',
            targeturl = 'javascript:void(0);',
            adType = 20,
            pic = '//img.58cdn.com.cn/n/images/list/noimg2.gif',
            anxuan = 'false',
            videourl = '',
            tag = [
                '押一付一',
                '精装修',
                '邻地铁',
                '押一付一',
                '精装修',
                '邻地铁'
            ],
            price = '',
            encryptUrl = '',
            ...info
        } = {},
        { showIndex, tag: paramTag,exposureInfo }
    ) => {
        let { title } = $data.getFangresult(cateid)(info),
            priceNum =
                price === '面议'
                    ? price
                    : price.replace(/([\u2E80-\u9FFF]|\/)*/g, ''),
            priceUnit = price === '面议' ? '' : price.replace(/\d|\-\.*/g, '')
        return `<a href="${targeturl}" class="list-item visiblereport-luna-card clickreport-luna-post ${
            adType === 20 ? 'list-item-hide' : ''
        }" data-tag="${paramTag}-${showIndex}" data-exposurelog='${exposureInfo}' data-adtype="${adType}" data-encrypturl="${encryptUrl}">
			<div class="img-container ${
                videourl ? 'canplay' : ''
            }"  style="background-image: url('${pic}')">
				${anxuan === 'true' ? '<span class="img-corner">安选</span>' : ''}
			</div>
			<ul class="content-container">
				<li class="title-line">${title}</li>
				<li class="tags-line">
					${tag.map(item => `<span class="tag">${item}</span>`).join('')}
				</li>
				<li class="price-line">
					<span class="num">${priceNum}</span>
					<span class="unit">${priceUnit}</span>
				</li>
			</ul>
		</a>`
    },
    fcdt2: (
        {
            cateid = '',
            adType = 20,
            targeturl = 'javascript:void(0);',
            anxuan = 'false',
            pic = '//img.58cdn.com.cn/n/images/list/noimg2.gif',
            videourl = '',
            applable = '房产标签',
            price = '',
            encryptUrl = '',
            ...info
        } = {},
        { showIndex, tag ,exposureInfo}
    ) => {
        let { title } = $data.getFangresult(cateid)(info),
            priceNum =
                price === '面议'
                    ? price
                    : price.replace(/([\u2E80-\u9FFF]|\/)*/g, ''),
            priceUnit = price === '面议' ? '' : price.replace(/\d|\-\.*/g, '')
        return `<a class="list-item visiblereport-luna-card clickreport-luna-post ${
            adType === 20 ? 'list-item-hide' : ''
        }" href="${targeturl}" data-tag="${tag}-${showIndex}" data-exposurelog='${exposureInfo}' data-adtype="${adType}" data-encrypturl="${encryptUrl}">
			<div class="img-container ${
                videourl ? 'canplay' : ''
            }" style="background-image: url('${pic}')">
				${anxuan === 'true' ? '<span class="img-corner">安选</span>' : ''}
			</div>
			<ul class="content-container">
				<li class="title-line">${title}</li>
				<li class="tags-line">
					${applable
                        .split(',')
                        .filter(item => !!item)
                        .map(item => `<span class="tag">${item}</span>`)
                        .join('')}
				</li>
				<li class="price-line">
					<span class="num">${priceNum}</span>
					<span class="unit">${priceUnit}</span>
				</li>
			</ul>
		</a>`
    },
    zpwt1: (
        {
            adType = 20,
            targeturl = 'javascript:void(0);',
            huiyuan = '',
            qiuzhibz = '',
            title = '标题正在路上',
            salary = '面议',
            gangwei = '职位',
            quyu = '区域',
            detailaddress = '商圈',
            xueliyaoqiu = '学历',
            nianxian = '经验不限',
            sid,
            infoId,
            slot,
            pos
        } = {},
        { showIndex, tag,exposureInfo }
    ) => {
        let tags = [detailaddress, xueliyaoqiu, nianxian]
        return `<a href="${targeturl}" class="list-item visiblereport-luna-card clickreport-luna-post ${
            adType === 20 ? 'list-item-hide' : ''
        }" data-tag="${tag}-${showIndex}" data-exposurelog='${exposureInfo}' data-infoid="${infoId}">
			${qiuzhibz || huiyuan ? `<i class="corner">${qiuzhibz || huiyuan}</i>` : ''}
			<ul class="content-container">
				<li class="title-line">${title}</li>
				<li class="salary-job-line">
					<span class="salary">${salary}</span>
					<span class="job">${gangwei}</span>
				</li>
				<li class="tags-line">
					${tags.join(' | ')}
				</li>
			</ul>
		</a>`
    },
    zpwt2: (
        {
            adType = 20,
            targeturl = 'javascript:void(0);',
            title = '标题正在路上',
            salary = '面议',
            gangwei = '职位',
            company = '公司名称',
            quxian = '',
            infoId,
            ...info
        } = {},
        { showIndex, tag ,exposureInfo}
    ) => {
        return `<a href="${targeturl}" class="list-item visiblereport-luna-card clickreport-luna-post ${
            adType === 20 ? 'list-item-hide' : ''
        }" data-tag="${tag}-${showIndex}" data-exposurelog='${exposureInfo}' data-title='${title}' data-tags='${$data.getJobFlbz(info)}' data-infoid="${infoId}">
			<button class="check">查看</button>
			<ul class="content-top">
				<li class="title-line">${title}</li>
				<li class="salary-job-line">
					<span class="salary">${salary}</span>
					<span class="job">${gangwei}</span>
				</li>
				<li class="tags-line">
					${$data
                        .getJobFlbz(info)
                        .map(item => `<span class="tag">${item}</span>`)
                        .join('')}
				</li>
			</ul>
			<div class="company">
				<span class="name">${company}</span>
				<span class="address">${quxian}</span>
			</div>
            <div class="${abtest.includes('advertising_rectification_a') && info.flbz && info.flbz.includes('广告') ? 'delIcon' : 'noIcon'}">
                <img src="//wos.58cdn.com.cn/cDazYxWcDHJ/picasso/etlmivee__w24_h24.png" alt="">
            </div>
		</a>`
    },
    zpkp: (
        {
            adType = 20,
            targeturl = 'javascript:void(0);',
            title = '标题正在路上',
            salary = '面议',
            gangwei = '职位',
            company = '公司名称',
            quxian = '',
            infoId,
            sid,
            slot,
            pos,
            ...info
        } = {},
        { showIndex, tag,exposureInfo }
    ) => {
        return `<a href="${targeturl}" class="list-item visiblereport-luna-card clickreport-luna-post ${
            adType === 20 ? 'list-item-hide' : ''
        }" data-tag="${tag}-${showIndex}" data-exposurelog='${exposureInfo}' data-title='${title}' data-tags='${$data.getJobFlbz(info)}' data-infoid="${infoId}">
			<button class="check">查看</button>
			<ul class="content-top">
				<li class="title-line">${title}</li>
				<li class="salary-job-line">
					<span class="salary">${salary}</span>
					<span class="job">${gangwei}</span>
				</li>
				<li class="tags-line">
					${$data
                        .getJobFlbz(info)
                        .map(item => `<span class="tag">${item}</span>`)
                        .join('')}
				</li>
			</ul>
			<div class="company">
				<span class="name">${company}</span>
				<span class="address">${quxian}</span>
			</div>
		</a>`
    }
}

/**
 * 列表内容 绘制 模块
 *
 * @param  {String} cateid
 * 职位类别id 用于拼 接请求的url
 *
 * @param  {String} catename
 * 职位类别name 用于拼接 更多按钮的链接
 *
 * @param  {Number} num
 * 接口返回个数, 注: 接口中返回adType=20的数据不算,反作弊条数直接隐藏
 *
 * @return {String}
 * 拼接后的dom
 */
function drawList_Content(
    container,
    cateid,
    catename,
    num,
    filter = '',
    listStyle,
    tip,
    listIndex,
    modelType = '',
    tag = ''
) {
    filter = filter
        ? `param=${filter
              .replace('u_', '')
              .split('=')
              .join(':')}`
        : ''
    $.ajax({
        type: 'get',
        url: `/xmladsvr/listads?n=${num}&cateid=${cateid}&city=${util.getActiveCityName()}&${filter}&adx_slot=lm_list_template&page=${window.pageFeedParams.pn}&page_id=${window.pageFeedParams.page_id}`,
        dataType: 'json',
        success: ({ status = 0, data = [] } = {}) => {
            if (status !== 0) {
                $(container)
                    .parent('.list-model')
                    .hide()
                return
            }
            if(window.pageFeedParams.feedTest === null) {
                const cardLen = data.filter(item => item.adType !== 20).length;
                window.pageFeedParams.feedTest = cardLen === 9 || cardLen === 15;
            }
            window.pageFeedParams.loading = false;
            bindUse400(container, data);
            bindListItemClick(container);
            var creativeid = ____json4fe.creativeid || ''
            var abtest = util.getCookie('abtest')
            var showIndex = 0
            if (typeof stategies[listStyle] !== 'function') return
            data.forEach(item => {
                const cityName = ____json4fe.locallist[0].name
                item.cateid = cateid
                if (['中国台湾', '中国澳门', '中国香港'].includes(cityName)) {
                    if (item.szone && !item.szone.includes('中国')) {
                        item.szone = `${cityName}，${item.szone}`
                    }
                    if (item.quyu2 && !item.quyu2.includes('中国')) {
                        item.quyu2 = `${cityName}-${item.quyu2}`
                    }
                    if (item.quxian && !item.quxian.includes('中国')) {
                        item.quxian = `${cityName}-${item.quxian}`
                    }
                    if (item.address && !item.address.includes('中国')) {
                        item.address = `${cityName}-${item.address}`
                    }
                }
            })
            // 创建fragment对象
            const fragment = document.createDocumentFragment()
            switch (listStyle) {
            case 'hypic':
                data
                    .map((item, index) => {
                        let exposureInfo = buildExposureInfo(item);
                        if (item.adType != 20) {
                            showIndex++
                        }
                        const itemEl = $(`${stategies[listStyle](item, {
                            index: index,
                            showIndex: showIndex,
                            catename: catename,
                            creativeid: creativeid,
                            abtest: abtest,
                            modelType,
                            tag,
                            exposureInfo
                        })}`)
                        fragment.appendChild(itemEl[0])
                        exposureRegister({
                            el:itemEl[0],
                            log:{element_id:4,module_id:'recommend_list'},
                            elementParamData:item
                        }),
                        bindListItemReport(itemEl,item)
                    })
                break
            case 'hynopic':
                data
                    .map((item, index) => {
                        let exposureInfo = buildExposureInfo(item);
                        if (item.adType != 20) {
                            showIndex++
                        }
                        const itemEl = $(`${stategies[listStyle](item, {
                            index: index,
                            showIndex: showIndex,
                            catename: catename,
                            creativeid: creativeid,
                            abtest: abtest,
                            modelType,
                            tag,
                            exposureInfo
                        })}`)
                        fragment.appendChild(itemEl[0])
                        exposureRegister({
                            el:itemEl[0],
                            log:{element_id:4,module_id:'recommend_list'},
                            elementParamData:item
                        }),
                        bindListItemReport(itemEl,item)
                    })
                    
                break
            case '2row':
                let subHtml = stategies[listStyle](data, tip)
                const itemEl =$(`<ul class="swiper-wrapper">${subHtml}</ul>`)
                fragment.appendChild(itemEl[0])
                break
            default:
                data
                    .map((item, index) => {
                        let exposureInfo = buildExposureInfo(item);
                        if (item.adType != 20) {
                            showIndex++
                        }
                        const itemEl = $(`${stategies[listStyle](item, {
                            index: index,
                            showIndex: showIndex,
                            listIndex: listIndex,
                            creativeid: creativeid,
                            abtest: abtest,
                            modelType,
                            tag,
                            exposureInfo
                        })}`)
                        fragment.appendChild(itemEl[0])
                        exposureRegister({
                            el:itemEl[0],
                            log:{element_id:4,module_id:'recommend_list'},
                            elementParamData:item
                        }),
                        bindListItemReport(itemEl,item)
                    })
                if (!['fcdt2', 'zpwt1'].includes(listStyle) && !data.length) {
                    window.pageFeedParams.canFeed = false;
                    const showMoreEl = $(`
							<a class="showMoreBtn clickreport"
								href="//luna.58.com/list.shtml?plat=m&city=${util.getActiveCityName()}&cate=${catename}&-15=20"
								data-tag="${tag.replace(/-[0-9]$/, '')}-more"
                                data-clickLog="___more__recommend_list"
							>
								查看更多推荐信息
								<i class="icon-greaterLabel"></i>
							</a>`)
                    fragment.appendChild(showMoreEl[0]) 
                }
                break
            }
            container
                .removeClass()
                .addClass('list-content')
                .addClass(`list-${listStyle}-content`)
            
            let pn = window.pageFeedParams.pn;
            if(!pn || pn === 1) {
                container.html('')
            }
            container[0].appendChild(fragment)
            console.log('fragment')   
            if (container.hasClass('list-2row-content')) {
                /*2行_单类轮播_信息列表模块 轮播图 初始化*/
                let listSwiperArr = util.initSwiper(container, {
                    autoplay: 3000,
                    direction: 'vertical',
                    autoplayDisableOnInteraction: false,
                    observer: true, //修改swiper自己或子元素时，自动初始化swiper
                    observeParents: true //修改swiper的父元素时，自动初始化swiper
                })
            }
            showFullTags_window($('.list-model-row-1 .tagBox'), 'span')
            exposureForCardUpdate()
            exposureUpdate();
        }
    })
}

var wordLimit = function(txt, len) {
    return txt.length > len ? `${txt.substr(0, len)}…` : txt
}

/**
 * [绑定400电话事件]
 */
var bindUse400 = function (container, list) {
    if (list.length > 0) {
        // 为方便下实验没有封装抽取，下线时直接删掉即可，hy_tel_optimize_a实验已经推全
        // if (getCookieValue('abtest').includes('hy_tel_optimize_a')) {
            container.on('click', '.list-item .telBox', async function () {
                if (window.telLoading) {
                    return
                }
                window.telLoading = true;
                let _img = document.createElement("img");
                _img.src = $(this).attr('data-url');
                const adType = $(this).attr('data-adtype')
                const params = {
                    infoId: $(this).attr('data-infoid'),
                    uniqueSign: $(this).attr('data-uniquesign'),
                    adtype: adType,
                    source: 1,
                    slot: $(this).attr('data-slot'),
                    sid: $(this).attr('data-sid'),
                    pos: $(this).attr('data-pos'),
                    busInfo: $(this).attr('data-businfo'),
                    busTransInfo: $(this).attr('data-busTransInfo'),
                }
                if(getCookieValue('abtest').includes('list_phone_pop_A') && adType === '43') {
                    const [err, response] = await window.$tcbAdxSdk.getPhoneNum(params)
                    if(!err && response.result) {
                        window.location.href = `tel:${response.result}`
                    }
                    window.telLoading = false
                } else {
                    window.$tcbAdxSdk.callHy({
                        ...params,
                        callback: (response) => {
                            const [res1, res2 = {}] = response || []
                            const { bindId, code } = res2 || {}
                            if (code === 0) {
                                if (typeof window.TCB_CLICKREPORT.clickReport === 'object') {
                                    const { clickReport: { send, buildExposureDefaultInfo, encodeObjectURIComponent, joinCompleteUrl, pageType } = {} } = window.TCB_CLICKREPORT || {};
                                    let _paramsObj = {}
                                    if (typeof buildExposureDefaultInfo === 'function') {
                                        _paramsObj = buildExposureDefaultInfo()
                                    }
                                    Object.assign(_paramsObj, {
                                        d: {
                                            page_type: pageType,
                                            element_id: bindId === 0 ? 61 : 60,
                                            element_param: {
                                                infoid: $(this).attr('data-infoid'),
                                                slot: $(this).attr('data-slot'),
                                                sid: $(this).attr('data-sid'),
                                                pos: $(this).attr('data-pos'),
                                            }
                                        }
                                    });
                                    send(joinCompleteUrl(encodeObjectURIComponent(_paramsObj)));
                                }
                            } else {
                                use400.getTelbyInfoId($(this).attr('data-infoid'))
                                // use400.telForList(container, '.list-item .telBox')
                            }
                            window.telLoading = false
                        }
                    })
                }
            })
        // } else {
        //     let uniquesign = ''
        //     uniquesign = list.filter(function (item) {
        //         return item.adType != 20
        //     })[0].uniquesign
        //     window.telLoading = false //调起400接口请求状态，避免重复请求
        //     if (uniquesign) {
        //         container.on('click', '.list-item .telBox', function () {
        //             if (window.telLoading) {
        //                 return
        //             }
        //             window.telLoading = true;
        //             let _img = document.createElement("img");
        //             _img.src = $(this).attr('data-url');
        //             window.$tcbAdxSdk.callHy({
        //                 infoId: $(this).attr('data-infoid'),
        //                 uniqueSign: $(this).attr('data-uniquesign'),
        //                 adtype: $(this).attr('data-adtype'),
        //                 source: 1,
        //                 slot: $(this).attr('data-slot'),
        //                 sid: $(this).attr('data-sid'),
        //                 pos: $(this).attr('data-pos'),
        //                 busInfo: $(this).attr('data-businfo'),
        //                 busTransInfo: $(this).attr('data-busTransInfo'),
        //                 callback: (response) => {
        //                     const [res1, res2 = {}] = response || []
        //                     const { bindId, code } = res2 || {}
        //                     if (code === 0) {
        //                         if (typeof window.TCB_CLICKREPORT.clickReport === 'object') {
        //                             const { clickReport: { send, buildExposureDefaultInfo, encodeObjectURIComponent, joinCompleteUrl, pageType } = {} } = window.TCB_CLICKREPORT || {};
        //                             let _paramsObj = {}
        //                             if (typeof buildExposureDefaultInfo === 'function') {
        //                                 _paramsObj = buildExposureDefaultInfo()
        //                             }
        //                             Object.assign(_paramsObj, {
        //                                 d: {
        //                                     page_type: pageType,
        //                                     element_id: bindId === 0 ? 61 : 60,
        //                                     element_param: {
        //                                         infoid: $(this).attr('data-infoid'),
        //                                         slot: $(this).attr('data-slot'),
        //                                         sid: $(this).attr('data-sid'),
        //                                         pos: $(this).attr('data-pos'),
        //                                     }
        //                                 }
        //                             });
        //                             send(joinCompleteUrl(encodeObjectURIComponent(_paramsObj)));
        //                         }
        //                     }
        //                     window.telLoading = false
        //                 }
        //             })
        //         })
        //     } else {
        //         use400.telForList(container, '.list-item .telBox')
        //     }
        // }
    }
}



/**
 * 帖子点击事件
 */
var bindListItemClick = function(container) {
    container.on('click', '.list-item', function() {
        const title = $(this).attr('data-title') || '';
        const tags = $(this).attr('data-tags') || [];
        const infoId = $(this).attr('data-infoid') || '';
        window.localStorage.setItem('creativityTitle', title);
        window.localStorage.setItem('creativityTags', tags);
        window.localStorage.setItem('creativityInfoId', infoId);
    })
}

/**
 * 列表展示完整标签
 * */
function showFullTags_window(container, selector) {
    container.each(function(i, e) {
        let offsetLeft_window = $(e).offset().left
        let width_window = $(e).width()
        $(e)
            .find(selector)
            .each(function(index, el) {
                let that = $(el)
                let offsetLeft = that.offset().left
                let width = that.width()
                if (offsetLeft + width > offsetLeft_window + width_window) {
                    that.hide()
                }
            })
    })
}

var bindListItemReport = function(el,data){
    try {
        el.on('click',function(){
            report({
                action:1003,
                element_id:4,
                module_id:'recommend_list'
            },data)
        })
    } catch (error) {
        console.log('luna-track bindListItemReport-error:', error);
    }
}
